import { Flex, IconButton, Typography } from '@aloft/toolkit-sui';
import { Td, Tr } from '../table.tsx';

export const Row = ({ label, children, includeClearButton, onClear }: { label: string; children?: React.ReactNode, includeClearButton?: boolean, onClear?: () => void }) => (
  <Tr>
    <Td>
      <Flex gap="5px" alignItems='center' paddingRight={includeClearButton ? '0' : '8px'}>
        <Typography variant='tableH1' color="textPrimary">{label}</Typography>
        {includeClearButton &&
          <IconButton
            ariaLabel='clear'
            icon="close-circle"
            variant="tertiary"
            onClick={onClear || (() => { })}
            size="xs"
            iconColor="buttonDefault"
            __dangerDoNotUseSx={{
              padding: 0,
              height: '16px',
              width: '16px',
              marginTop: '2px',
            }}
          />
        }
      </Flex>
    </Td>
    {children}
  </Tr>
)
